/** 场景库 / 策略库（F-003 / F-011），localStorage 持久化，刷新后仍在（AC-F011-01）。 */
import { create } from 'zustand';
import { loadJSON, saveJSON } from '../data/storage';
import type { SetupFields } from './store';
import type { Rule } from '../strategy/rule-engine/rule-model';

export interface SavedScenario {
  readonly name: string;
  readonly setup: SetupFields;
}
export interface SavedStrategy {
  readonly name: string;
  readonly rules: Rule[];
}

interface LibraryState {
  scenarios: SavedScenario[];
  strategies: SavedStrategy[];
  addScenario: (name: string, setup: SetupFields) => void;
  removeScenario: (name: string) => void;
  addStrategy: (name: string, rules: Rule[]) => void;
  removeStrategy: (name: string) => void;
}

const KEY_SCN = 'scenarios';
const KEY_STR = 'strategies';

export const useLibrary = create<LibraryState>(() => ({
  scenarios: loadJSON<SavedScenario[]>(KEY_SCN) ?? [],
  strategies: loadJSON<SavedStrategy[]>(KEY_STR) ?? [],
  addScenario: (name, setup) => {
    const next = [...useLibrary.getState().scenarios.filter((s) => s.name !== name), { name, setup }];
    saveJSON(KEY_SCN, next);
    useLibrary.setState({ scenarios: next });
  },
  removeScenario: (name) => {
    const next = useLibrary.getState().scenarios.filter((s) => s.name !== name);
    saveJSON(KEY_SCN, next);
    useLibrary.setState({ scenarios: next });
  },
  addStrategy: (name, rules) => {
    const next = [...useLibrary.getState().strategies.filter((s) => s.name !== name), { name, rules }];
    saveJSON(KEY_STR, next);
    useLibrary.setState({ strategies: next });
  },
  removeStrategy: (name) => {
    const next = useLibrary.getState().strategies.filter((s) => s.name !== name);
    saveJSON(KEY_STR, next);
    useLibrary.setState({ strategies: next });
  },
}));
